import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { 
  FaSpinner, 
  FaAngleLeft, 
  FaAngleRight, 
  FaAngleDoubleLeft, 
  FaAngleDoubleRight 
} from "react-icons/fa";
import { useState } from "react";
import { TiDelete } from "react-icons/ti";
import { IconContext } from "react-icons/lib";
import { useEffect } from "react";

function DefaultFilterForColumn({
  column: { Header, filterValue, setFilter, id },
}) {
  var timer;
  const handleChange = (e) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      setFilter(e.target.value || undefined);
      clearTimeout(timer);
    }, 400);

    // setFilter(e.target.value || undefined);
  };
  const handleRemove = (e) => {
    // console.log(document.getElementById(id).value);
    document.getElementById(id).value = "";

    setFilter(undefined);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="relative">
        <input
          className={`w-full py-1 pl-1 rounded text-sm inline ${
            filterValue ? " bg-sky-900" : "bg-bg text-text"
          }`}
          onChange={handleChange}
          placeholder={`${Header} 검색`}
          id={id}
        />
        {filterValue !== undefined ? (
          <IconContext.Provider
            value={{
              attr: {
                onClick: (e) => {
                  handleRemove(e);
                },
                onMouseOver: (e) => {
                  e.target.style.color = "white";
                  e.target.style.cursor = "hand";
                },
                onMouseOut: (e) => {
                  e.target.style.color = "gray";
                },
              },
              style: {
                display: "inline",
                position: "absolute",
                right: "0.1rem",
                top: "0.25rem",
                color: "gray",
                fontSize: "1.3rem",
              },
            }}
          >
            <TiDelete />
          </IconContext.Provider>
        ) : (
          ""
        )}
      </div>
    </form>
  );
}

export default function TableContent({
  isLoading,
  columns,
  data,
  itemPerPage,
  handleChartInfo,
  enableCompactControlPanel,
  disableControlPanel,
  disableKeyboardNavigation,
  useUniformWidth,
  children,
  pageType,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: {
        Filter: DefaultFilterForColumn,
      },
      initialState: { pageIndex: 0, pageSize: itemPerPage ? itemPerPage : 30 },
      autoResetFilters: false,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const randomSignatureForFlag = new Date().getUTCMilliseconds(); // 토글용 랜덤 id 생성
  const [selectedData, setSelectedData] = useState({});

  const PaginationButton = ({ onClick, disabled, children }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`p-2 rounded-full hover:bg-gray-200 transition-colors ${
        disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-600 hover:text-indigo-600"
      }`}
    >
      {children}
    </button>
  );

  const ControlPanel = () => {
    return (
      <div className="flex flex-col md:flex-row items-center justify-between w-full px-4 py-3 select-none bg-white border-t border-gray-200 rounded-b-lg gap-2 md:gap-0">
        <div className="flex items-center space-x-2">
          <select
            className="px-2 py-1 text-xs md:text-sm text-gray-700 bg-white border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 60, 80, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize} 개씩
              </option>
            ))}
          </select>
          <span className="text-xs md:text-sm text-gray-500">
            총 {pageOptions.length} 페이지
          </span>
        </div>

        <div className="flex items-center space-x-1">
          <PaginationButton onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            <FaAngleDoubleLeft />
          </PaginationButton>
          <PaginationButton onClick={() => previousPage()} disabled={!canPreviousPage}>
            <FaAngleLeft />
          </PaginationButton>

          <div className="flex items-center px-2 md:px-4">
            <span className="text-xs md:text-sm text-gray-500 mr-2">Page</span>
            <input
              className="w-10 md:w-12 px-1 text-center text-xs md:text-base text-gray-700 bg-white border border-gray-300 rounded focus:outline-none focus:border-indigo-500"
              type="number"
              value={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
            />
          </div>

          <PaginationButton onClick={() => nextPage()} disabled={!canNextPage}>
            <FaAngleRight />
          </PaginationButton>
          <PaginationButton onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            <FaAngleDoubleRight />
          </PaginationButton>
        </div>
      </div>
    );
  };

  const CompactControlPanel = () => {
    return (
      <div className="flex items-center justify-between px-2 py-1 bg-white border-t border-gray-200 rounded-b-lg">
        <div className="flex items-center">
          <button
            className={`p-1 ${!canPreviousPage ? "text-gray-400" : "text-gray-600 hover:text-indigo-600"}`}
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            <FaAngleLeft />
          </button>
          <button
            className={`p-1 ${!canNextPage ? "text-gray-400" : "text-gray-600 hover:text-indigo-600"}`}
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            <FaAngleRight />
          </button>
        </div>
        <span className="text-xs text-gray-500">
          <span className="text-gray-900 font-medium">{pageIndex + 1}</span> / {pageOptions.length}
        </span>
      </div>
    );
  };

  const handleClick = (e, row) => {
    if (!handleChartInfo) {
      return;
    }
    if (data[row.id].code !== undefined) {
      handleChartInfo({
        company_id: data[row.id].company_id,
        name: data[row.id].name,
        code: data[row.id].code,
        row: row,
      });

      const willremove = document.getElementsByName(randomSignatureForFlag);
      Array.from(willremove).forEach((item) => {
        // 기존 선택 스타일 제거
        item.classList.remove("bg-indigo-50"); 
        item.classList.remove("text-indigo-700");
      });

      // 선택된 행 스타일 적용
      e.currentTarget.classList.add("bg-indigo-50");
      e.currentTarget.classList.add("text-indigo-700");
      setSelectedData(data[row.index]);
    } else {
      handleChartInfo("", "", row);
    }
  };

  useEffect(() => {
    setSelectedData();
  }, [data, randomSignatureForFlag]);

  // 키보드 네비게이션 핸들러
  useEffect(() => {
    if (disableKeyboardNavigation) return; // 키보드 네비게이션 비활성화 시 리턴

    const handleKeyDown = (e) => {
      // 로딩 중이거나, 입력 요소에 포커스가 있을 경우 무시
      if (
        isLoading ||
        ["INPUT", "TEXTAREA"].includes(document.activeElement.tagName)
      ) {
        return;
      }

      if (e.key === "ArrowLeft" && canPreviousPage) {
        previousPage();
      } else if (e.key === "ArrowRight" && canNextPage) {
        nextPage();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isLoading, canPreviousPage, canNextPage, previousPage, nextPage, disableKeyboardNavigation]);

  return (
    <div className="flex flex-col w-full px-2 pb-4 md:px-4 md:pb-6 text-gray-800">
      <div className="mb-2">{children}</div>
      
      <div
        className={`flex flex-col items-center justify-center py-10 ${
          !isLoading ? "hidden" : ""
        }`}
      >
        <FaSpinner className="text-4xl text-indigo-500 animate-spin mb-4" />
        <div className="text-lg text-gray-500">데이터를 불러오는 중입니다...</div>
      </div>

      <div className={`shadow-sm rounded-lg overflow-hidden bg-white border border-gray-200 ${isLoading ? "hidden" : ""}`}>
        {selectedData?.url ? (
          <div className="flex flex-col p-3 text-sm font-medium text-center text-indigo-700 bg-indigo-50 border-b border-indigo-100 sm:flex-row sm:justify-center sm:gap-6">
            <a
              href={`${selectedData.url}`}
              target="_blank"
              rel="noreferrer"
              className="hover:text-indigo-900 transition-colors flex items-center justify-center gap-1"
            >
              <span>📄</span> {selectedData.name} ({selectedData.date}) 공시 보기 (Dart)
            </a>
            <a
              href={`https://finance.naver.com/item/coinfo.naver?code=${selectedData.code
                .toLowerCase()
                .replace("a", "")}`}
              target="_blank"
              rel="noreferrer"
              className="hover:text-indigo-900 transition-colors flex items-center justify-center gap-1"
            >
              <span>📈</span> {selectedData.name} 재무정보 보기 (Naver)
            </a>
          </div>
        ) : null}

        <div className="overflow-x-auto">
          <table {...getTableProps()} className="w-full text-left border-collapse tabular-nums">
            <thead className="bg-gray-50 text-gray-600 border-b border-gray-200 sticky top-0 z-10 shadow-sm">
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps()}
                      className="px-2 py-2 text-xs md:px-4 md:py-3 md:text-sm font-bold tracking-wide whitespace-nowrap bg-gray-50/95 backdrop-blur-sm"
                    >
                      <div className="flex items-center justify-between w-full gap-2">
                        {!column.canSort && !column.canFilter
                          ? <div>{column.render("Header")}</div>
                          : null}
                        
                        <div
                          className={`flex items-center justify-between w-full gap-1 ${
                            column.canFilter || column.canSort ? "" : "hidden"
                          }`}
                        >
                          <div
                            className={`flex items-center cursor-pointer hover:text-gray-900 transition-colors shrink-0 ${
                              !column.canSort ? "hidden" : ""
                            }`}
                            {...column.getHeaderProps(column.getSortByToggleProps())}
                          >
                            <div className="text-left">
                              {column.canSort ? column.render("Header") : null}
                            </div>
                            <span className="ml-1 text-xs text-gray-400">
                              {column.canSort
                                ? column.isSorted
                                  ? column.isSortedDesc
                                    ? "▼"
                                    : "▲"
                                  : "⇅"
                                : ""}
                            </span>
                          </div>
                          <div className="flex-1">
                            {column.canFilter ? column.render("Filter") : null}
                          </div>
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()} className="divide-y divide-gray-100">
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className="hover:bg-indigo-50/30 transition-all duration-200 group border-l-4 border-l-transparent hover:border-l-indigo-500"
                    name={`${randomSignatureForFlag}`}
                    onClick={(e) => handleClick(e, row)}
                  >
                    {row.cells.map((cell) => {
                      // 1. 긴 텍스트 컬럼: 너비 확보 및 줄바꿈 허용
                      // useUniformWidth가 true인 경우 긴 텍스트 처리를 하지 않음
                      const isLongTextColumn = !useUniformWidth && ["reason", "content", "subject", "desc"].some(key => cell.column.id.toLowerCase().includes(key));
                      
                      if (isLongTextColumn) {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className="px-2 py-2 text-xs md:px-4 md:py-3 md:text-sm text-gray-600 min-w-[300px] whitespace-normal break-keep"
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      }

                      // 2. 일반 컬럼: 너비 고정 및 폰트 동적 조절
                      // 너비 설정
                      let widthClass = "w-28";
                      if (!useUniformWidth) {
                        if (cell.column.id === "name") widthClass = pageType === "updown" ? "w-40" : "w-60"; 
                        else if (cell.column.id === "person" || cell.column.id === "holder") widthClass = "w-44"; 
                        else if (cell.column.id === "person_rank") widthClass = "w-32";
                        else if (["share_change", "current_ratio", "previous_ratio", "change"].includes(cell.column.id)) widthClass = "w-24";
                        else if (cell.column.id.toLowerCase().includes("date")) widthClass = "w-24";
                        else if (["revenue", "profit"].some(k => cell.column.id.toLowerCase().includes(k))) widthClass = "w-20";
                      } else if (cell.column.id.toLowerCase().includes("date")) {
                        widthClass = "w-24";
                      }

                      // 폰트 사이즈 동적 조절
                      // 숫자인 경우 소수점 자릿수 때문에 실제 표시보다 길게 계산될 수 있음
                      let displayValue = "";
                      if (typeof cell.value === 'number') {
                        // 수치 데이터는 보통 2~3자리 소수점만 표시되므로 이를 반영하여 길이 계산
                        displayValue = cell.value.toFixed(2);
                      } else {
                        displayValue = typeof cell.value === 'object' ? '' : cell.value?.toString() || "";
                      }
                      
                      const len = displayValue.length;
                      let fontSizeClass = "text-xs md:text-sm"; // 기본: 모바일 xs, PC sm
                      
                      // 특정 컬럼들에 대해 글자수가 많을 경우 폰트 축소
                      if (!useUniformWidth) {
                        const targetIds = ["name", "person", "holder", "person_rank", "share_change", "current_ratio", "previous_ratio", "change"];
                        if (targetIds.includes(cell.column.id)) {
                          // 너비에 따른 임계값 조정
                          const thresholdLarge = widthClass === "w-44" ? 14 : 10;
                          const thresholdSmall = widthClass === "w-44" ? 10 : 8;
                          
                          if (len > thresholdLarge) fontSizeClass = "text-[10px] md:text-[11px]";
                          else if (len > thresholdSmall) fontSizeClass = "text-[11px] md:text-xs";
                        } else {
                          // 기존 로직 유지
                          if (len > 15) fontSizeClass = "text-[11px] md:text-[11px]"; 
                          else if (len > 10) fontSizeClass = "text-[11px] md:text-xs";
                        }
                      }
                      
                      // 회사명일 경우 강조 스타일 추가
                      const extraStyle = cell.column.id === "name" ? "font-bold text-gray-900" : "";

                      // useUniformWidth일 때 reason 컬럼 등은 줄바꿈 허용 (너비는 고정)
                      const whiteSpaceClass = (useUniformWidth && ["reason", "content"].some(k => cell.column.id.toLowerCase().includes(k))) 
                        ? "whitespace-normal break-keep" 
                        : "whitespace-nowrap";

                      return (
                        <td
                          {...cell.getCellProps()}
                          className={`px-2 py-2 md:px-4 md:py-3 text-gray-600 ${whiteSpaceClass} ${widthClass} ${fontSizeClass} ${extraStyle}`}
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div>
          {enableCompactControlPanel ? (
            <CompactControlPanel />
          ) : !disableControlPanel ? (
            <ControlPanel />
          ) : null}
        </div>
      </div>
    </div>
  );
}
